import { __module as t } from "../../../_virtual/isBIC.js";
import { a as e } from "./util/assertString.js";
import "./isISO31661Alpha2.js";
import { __exports as s } from "../../../_virtual/isISO31661Alpha2.js";
Object.defineProperty(r = t.exports, "__esModule", {
  value: !0
}), r.default = function (t) {
  return (0, a.default)(t), !!s.CountryCodes.has(t.slice(4, 6).toUpperCase()) && o.test(t);
}, a = e && e.__esModule ? e : {
  default: e
}, o = /^[A-Za-z]{6}[A-Za-z0-9]{2}([A-Za-z0-9]{3})?$/, t.exports = r.default, t.exports.default = r.default;
var r,
  a,
  o,
  i = t.exports;
export { i };